var ready = require('./ready.js');

function toggle(id, show) {
    var target = document.getElementById(id);
    if (!target) {
        throw new Error('Can\'t find modal target with id ' + id);
    }

    target.classList.toggle('visible', show);
    document.body.classList.toggle('modal-open', show)
}

function eachSelector(selector, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), fn);
}

function setupButtons(className, show) {
    eachSelector(className, function(el) {
        el.addEventListener('click', function(event) {
            event.preventDefault();
            toggle(el.dataset.target, show);
        });
    });
}

ready(function() {
    setupButtons('.open-modal', true);
    setupButtons('.close-modal', false);

    eachSelector('.modal', function(el) {
        el.addEventListener('click', function(event) {
            // Make sure to only react if the background itself was clicked
            if (event.target !== event.currentTarget) { return; }
            toggle(el.id, false);
        })
    });
});
